// extracted by mini-css-extract-plugin
export default {"melodyVideo":"rM-z","isFullWidth":"sM-z","landingPageVideo":"tM-z","play":"uM-z","iframeVideo":"vM-z","playHidden":"wM-z","fullwidth":"xM-z"};